import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SuiContainer } from '@splashthat/sui';

import BorderEditor from 'common/components/BorderPicker';
import ColorPickerEditor from 'common/components/ColorPicker';
import Spacer from 'common/components/Spacer';
import { containerPaddingS } from 'common/styles/variables';
import { getColors } from 'common/entities/color/selectors';
import {
    setAllFormSessionBadgeBorderSizes,
    setFormSessionBadgeBorderColor,
    setFormSessionBadgeBorderRadius,
    setFormSessionBadgeBorderSizeBottom,
    setFormSessionBadgeBorderSizeLeft,
    setFormSessionBadgeBorderSizeRight,
    setFormSessionBadgeBorderSizeTop,
} from 'common/entities/form/styleConfiguration/actions';
import { getBadgeBorderStyles } from 'common/entities/form/styleConfiguration/selectors';

import { BADGE_BORDER_QA, SESSION_DETAILS_QA } from '../../../../utils/qaIdConstants';
import { SESSION_DETAILS_BADGE_BORDER_LABEL } from '../../../../constants/formStyleLabels';
import { COLLAPSIBLE_SECTION } from '../../../../constants/reusableClassNames';
import { getFormId } from '../../../../selectors';

const SessionDetailsBadgeBorderPanel = () => {
    const dispatch = useDispatch();
    const formId = useSelector(getFormId);
    const colorList = useSelector(getColors);
    const {
        color,
        radius: borderRadius,
        ...borderWidths
    } = useSelector((state) => getBadgeBorderStyles(state, formId));

    return (
        <SuiContainer className={COLLAPSIBLE_SECTION} data-qa={`${SESSION_DETAILS_QA}--section-${BADGE_BORDER_QA}`}>
            <BorderEditor
                borderWidths={borderWidths}
                onBorderWidthsChanged={(widths) => dispatch(setAllFormSessionBadgeBorderSizes(formId, widths))}
                borderRadius={borderRadius}
                onBorderRadiusChanged={(radius) => dispatch(setFormSessionBadgeBorderRadius(formId, radius))}
                onChangeTopBorderWidth={(width) => dispatch(setFormSessionBadgeBorderSizeTop(formId, width))}
                onChangeBottomBorderWidth={(width) => dispatch(setFormSessionBadgeBorderSizeBottom(formId, width))}
                onChangeRightBorderWidth={(width) => dispatch(setFormSessionBadgeBorderSizeRight(formId, width))}
                onChangeLeftBorderWidth={(width) => dispatch(setFormSessionBadgeBorderSizeLeft(formId, width))}
                borderOptionsQa={`${SESSION_DETAILS_QA}--badge-borderOptions`}
                borderDropdownQa={`${SESSION_DETAILS_QA}--badge-borderDropdown`}
                componentLabel={SESSION_DETAILS_BADGE_BORDER_LABEL}
            />
            <Spacer $spacing={containerPaddingS} />
            <ColorPickerEditor
                colorList={colorList}
                firstColor={color}
                changeFirstColor={(id) => dispatch(setFormSessionBadgeBorderColor(formId, id))}
                qaId={SESSION_DETAILS_QA}
            />
        </SuiContainer>
    );
};

export default SessionDetailsBadgeBorderPanel;
